// 合作申请
export default [
  {
    path: "/cooperationApplication",
    name: "cooperationApplication",
    meta: { title: "合作申请" },
    component: () => import("../views/cooperationApplication/index"),
    children: [
      {
        path: "/cooperationApplication/list",
        name: "cooperationApplicationList",
        meta: { title: "合作申请列表", isMenu: true },
        component: () => import("../views/cooperationApplication/list"),
      },
      {
        path: "/cooperationApplication/list/details",
        name: "cooperationApplicationDetails",
        meta: { title: "合作申请详情" },
        component: () => import("../views/cooperationApplication/detail/details"),
      },
    ],
  },
]